"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getChatApiMetaData = getChatApiMetaData;
var _common = require("./common");
var _jsSha = _interopRequireDefault(require("js-sha256"));
function getChatApiMetaData(config) {
  if (!config || !config.hmacPwd) {
    return Promise.reject();
  }
  var requestId = _jsSha.default.hmac(config.hmacPwd, config.featureApiHmacKey);
  var options = {
    method: 'GET',
    mode: 'cors',
    headers: {
      'x-chat-request-id': requestId,
      'x-accept-version': 2
    },
    credentials: 'include'
  };
  var query_params = [];
  if (config.lang) {
    query_params.push("lang=".concat(config.lang));
  }
  if (config.appkey) {
    query_params.push("appkey=".concat(config.appkey));
  } else {
    query_params.push('appkey=panamera');
  }
  if (query_params.length > 0) {
    config.featureApi = "".concat(config.featureApi, "?").concat(query_params.join('&'));
  }
  return (0, _common.request)(config.featureApi, options).then(function (res) {
    if (res) {
      return res;
    }
    throw new Error();
  });
}